module.exports = __webpack_public_path__ + "img/product.4892f319.svg";